import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_ResolutionIncreaser = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/resolution-increaser',
			name: 'AI Resolution Increaser',
			description:
				'Enhance image resolution instantly. Online image resolution increaser, no watermarks.',
			url: 'https://liftapp.ai/resolution-increaser',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/resolution-increaser#product' },
				{ '@id': 'https://liftapp.ai/resolution-increaser#howto' },
				{ '@id': 'https://liftapp.ai/resolution-increaser#benefits' },
				{ '@id': 'https://liftapp.ai/resolution-increaser#faq' },
				{ '@id': 'https://liftapp.ai/resolution-increaser#why-lift' },
				{ '@id': 'https://liftapp.ai/resolution-increaser#explore-tools' },
				{ '@id': 'https://liftapp.ai/resolution-increaser#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/resolution-increaser#product',
			name: 'AI Resolution Increaser',
			description:
				'Enhance image resolution instantly. Online image resolution increaser, no watermarks.',
			url: 'https://liftapp.ai/resolution-increaser',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: 4.8,
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/resolution-increaser#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: 'Choose a photo from your device or take one using Lift’s app',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Upgrade with AI',
					text: "Lift's AI resolution increaser converts your image to high resolution while reconstructing missing details",
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/resolution-increaser#benefits',
			name: 'Who can benefit from AI Image Quality Improver?',
			description:
				'Lift AI Image Quality Improver helps e-commerce sellers, content creators, marketers, and more improve image quality instantly with AI retouching.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'AI Resolution Increaser is perfect for anyone needing to upgrade image quality and size',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Content creators and influencers for professional-looking posts',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Businesses and e-commerce sellers improving product visuals',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Event planners preserving memories in crisp detail',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Students or professionals can clarify scanned documents, screenshots, or images',
				},
				{
					'@type': 'ListItem',
					position: 6,
					name: 'Photographers can restore older or low-quality images effortlessly',
				},
				{
					'@type': 'ListItem',
					position: 7,
					name: 'AI Resolution Increaser transforms pixelated images into crisp, high-quality visuals, making it indispensable for professional and personal projects',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/Landing_2.bd03ea58.webp',
				name: 'Benefit from Resolution Increaser',
				description:
					'Smiling woman’s face enhanced from blurred view behind hand',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/resolution-increaser#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Resolution Increaser?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Resolution Increaser is a premium online tool that increases your image resolution up to 4× without losing sharpness or quality — perfect for printing, e-commerce or HD displays.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does the resolution increaser work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'AI Resolution Increaser uses advanced super-resolution technology to rebuild pixel details and sharpen edges while preserving natural textures. Everything happens in the cloud — just upload, choose your scale (2× or 4×), and get stunning results in seconds.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can it convert very small images to high resolution?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift can upgrade images from any starting resolution to high resolution, including 2K and 4K. The AI reconstructs details even when the original image is small or heavily compressed.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the result without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/resolution-increaser#why-lift',
			name: "Why Lift's AI Resolution Increaser stands out",
			description:
				'Lift AI Resolution Increaser provides professional results, AI accuracy, cross-platform support, and is budget-friendly.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Professional results',
					description:
						'Achieve studio-quality images without the need for complex tools',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI accuracy',
					description:
						'Smart algorithms deliver enhancements tailored to your specific image',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly editing services with Lift’s affordable solution',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/Landing_3.0a2b4e1b.webp',
				name: 'Edited with Lift',
				description:
					'Blurry group of women in front of a building turned crisp and vibrant',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-extender#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/resolution-increaser#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI Resolution Increaser',
					item: 'https://liftapp.ai/resolution-increaser',
				},
			],
		},
	],
};
